module.exports = __webpack_public_path__ + "img/under_maintenance.6b1772b6.gif";